import { fetchPartners } from "@/server/api-services";
import { Partner } from "@/types";
import { useState, useEffect } from "react";
import PartnerPageHeader from "./page-header";
import PartnerListTable from "@/app/shared/settings/partners/list/table";



export default function PartnerListPage() {
    const [partners, setPartners] = useState([] as Partner[]);

    useEffect(() => {
        loadPartners();
    }, []);

    async function loadPartners() {
        const response = await fetchPartners();

        

        if (response.statusCode !== 200) {
            return;
        }

        var data = response.data as Partner[];

        setPartners(data);
    }

    const refresh = () => loadPartners();

    return (
        <>
            <PartnerPageHeader title="Partner" hideButton={false} />
            <PartnerListTable
                partners={partners}
                refresh={refresh}
            />
        </>
    );
}
